import { SoftLoginRequestParams } from "commonModule/services/auth/softLogin"
import { PropertyTypeV2 } from "commonModule/services/common"
import { PriceDropAlertRequestData } from "commonModule/services/priceDropAlert"
import { UserResponseData } from "commonModule/services/user"
import { UserBasicDetails } from "services/common"

export type UserState = {
  about: string | null
  active: boolean
  appVersion: string | null
  browserType: string | null
  channel: string | null
  city: string | null
  country: string | null
  currency: string | null
  deactiveDt: string | null
  dialerCode: string | null
  dobDt: string | null
  emailId: string | null
  emailVerified: boolean
  firstName: string | null
  fullName: string | null
  gender: string | null
  hostFeePercentage: number
  hostWebsite: string | null
  identificationId: string | null
  invCode: string | null
  ipAddress: string | null
  isAdmin: boolean
  isHost: boolean
  isTraveler: boolean
  isTrmsncndAccepted: boolean
  language: string | null
  lastName: string | null
  listingStatus: boolean
  location: string | null
  macId: string | null
  middleName: string | null
  mobileno1: string | null
  mobileno2: string | null
  notificationApp: boolean
  notificationEmail: boolean
  notificationSms: boolean
  password: string | null
  phNo: string | null
  pmsType: string | null
  profileImageFullPath: string | null
  profileImg: string | null
  servicefeeforhostId: number
  signinFrom: string | null
  signinProvider: string | null
  signinProviderId: string | null
  socialProfileImageURL: string | null
  state: string | null
  superhogUserId: string | null
  travelerRatingStarSum: number
  travelerRatingUserCount: number
  trmsncndAcceptedDate: string | null
  trmsncndAcceptedVersion: string | null
  userId: number
  userType: number
  zipcode: string | null
}

export type PmcState = {
  companyName: string | null
  pmcId: string
}

export type AuthUI = Partial<{
  isSigningUpWithEmail: boolean
  isLoginFlow: boolean
  isVerifyEmailModalOpen: boolean
  isEmailSent: boolean
  newLoginSignUpType?:
    | null
    | "LOGIN_WITH_EMAIL"
    | "LOGIN_WITH_PHONE"
    | "SIGNUP"
    | "SIGNUP_DETAILS_FORM"
    | "OTP_OR_PASSWORD_FROM"
    | "FORGOT_PASSWORD"

  modalType?:
    | null
    | "LOGIN_WITH_EMAIL"
    | "LOGIN_WITH_PHONE"
    | "SIGNUP"
    | "SIGNUP_DETAILS_FORM"
    | "OTP_OR_PASSWORD_FROM"
    | "FORGOT_PASSWORD"

  isSuspendedModalOpen: boolean

  /** Whether the user has clicked on the price drop alert */
  isLoginInitiatedFromPriceDrop: boolean
  /**
   * Action to perform after login/signup is successful.
   * This is typically used to redirect the user or perform some action
   * after the user has logged in or signed up.
   * Like if login modal is opened when user tries to add property to favorites,
   * then we can pass this function when opening the login modal and call it after login is successful.
   */
  actionToPerformAfterLoginOrSignup?: null | (() => void)
}>

export enum SoftLoginModalType {
  FAV_SOFT_LOGIN = "FAV_SOFT_LOGIN",
  PDA_SOFT_LOGIN = "PDA_SOFT_LOGIN",
  MSG_HOST_SOFT_LOGIN = "MSG_HOST_SOFT_LOGIN",
  BOOKING_SOFT_LOGIN = "BOOKING_SOFT_LOGIN",
}
export type SoftLoginSendMessagePayload = {
  property: PropertyTypeV2
  coverImg: string
  aboutHost: {
    hostId: number | string
    hostProfileName: string | null
    hostProfileUrl: string | null
  }
  pmcHost?: {
    hostName: string
    whimstayUserId: string | number
  }
}
export type SoftLoginStateType = {
  isUserSoftLoggedIn?: boolean
  softLoginType: null | SoftLoginModalType
  softLoginPayload: SoftLoginRequestParams
  softSignupType?: null | SoftLoginModalType
  softSignupTitle?: string
  softSignupDescription?: string
  softSignupSubTitle?: string
  softSignupCheckboxText?: string
  isSoftSignup?: boolean
  softLoginSendMessagePayload?: SoftLoginSendMessagePayload | null
  /**
   * Action to perform after soft login is successfull.
   */
  actionToPerformAfterSoftLogin?: null | (() => void)
  /** Action to perform after soft signup is successful
   * (triggered when the user clicks the favorite icon without being logged in).
   */
  setPDAAPIsPayloadData?: {
    data?: PriceDropAlertRequestData | null
    desc: string
  } | null
}
export type AuthInitialState = {
  countryCode: string | null
  dialCode: string | null
  emailId: string | null
  error: string | null
  errorCode: string | null
  isLoggedIn: boolean
  isTermAccepted: boolean
  loading: boolean
  isFirstLogin: boolean
  mobileNumber: string | null
  ui: AuthUI
  user?: Partial<UserResponseData>
  userBasicDetails?: UserBasicDetails
  userExists: boolean

  isArriveFromHomePage: boolean
  userInfoFromGoogle: null | {
    firstName?: string | null
    lastName?: string | null
    emailAddress: string
  }
  userInfoFromApple: null | {
    firstName?: string | null
    lastName?: string | null
    emailAddress: string
  }

  softLogin: SoftLoginStateType
}
